import { Injectable } from '@angular/core';

declare var __xwc__;

@Injectable({
  providedIn: 'root'
})
export class ContextService {
  get token(): string {
    if (typeof __xwc__ === 'object' && typeof __xwc__.token === 'string') {
      return __xwc__.token;
    } else {
      return null;
    }
  }

  get fiscalId(): number | null {
    if (typeof __xwc__ === 'object' && typeof __xwc__.fiscalId === 'number') {
      return __xwc__.fiscalId;
    } else {
      return null;
    }
  }

  get serviceUrl(): string {
    if (typeof __xwc__ === 'object' && typeof __xwc__.apiBaseUrl === 'string') {
      return __xwc__.apiBaseUrl;
    } else {
      throw new Error('__xwc__.apiBaseUrl is required to be a string');
    }
  }

  get webBaseUrl(): string {
    if (typeof __xwc__ === 'object' && typeof __xwc__.webBaseUrl === 'string') {
      return __xwc__.webBaseUrl;
    } else {
      throw new Error('__xwc__.webBaseUrl is required to be a string');
    }
  }
}
